import type { Actions, State } from './typings'
import {
  activityTypeUpdatedProducer,
  closeActivityTypeFormProducer,
  closeDeleteDialogProducer,
  createActivityTypeProducer,
  deleteActivityTypeProducer,
  fetchActivityByIdProducer,
  fetchAllActivityTypesProducer,
  openActivityTypeFormProducer,
  openDeleteDialogProducer,
  updateActivityTypeProducer,
} from './actions'

export function reducer(state: State, action: Actions) {
  switch (action.type) {
    case 'activityTypeForm/openForm':
      return openActivityTypeFormProducer(state, action.payload)
    case 'activityTypeForm/closeForm':
      return closeActivityTypeFormProducer(state)
    case 'activityTypes/fetchAll':
      return fetchAllActivityTypesProducer(state, action.payload)
    case 'activityTypes/create':
      return createActivityTypeProducer(state, action.payload)
    case 'activityTypes/delete':
      return deleteActivityTypeProducer(state, action.payload)
    case 'activityType/fetch':
      return fetchActivityByIdProducer(state, action.payload)
    case 'activityTypes/update':
      return updateActivityTypeProducer(state, action.payload)
    case 'activityTypes/openDeleteDialog':
      return openDeleteDialogProducer(state, action.payload)
    case 'activityTypes/closeDeleteDialog':
      return closeDeleteDialogProducer(state)
    case 'activityTypes/updated':
      return activityTypeUpdatedProducer(state, action.payload)
    default:
      return { ...state }
  }
}
